import ReportingDashboard from "../../components/reportingDashbaord/ReportingDashbaord";
import { useSelector } from 'react-redux';
import adminLogo from '../../Images/admin_img.jpg';
import mbHomeImg1 from '../../Images/mb_home_page_bg_1.jpg';
import mbHomeImg2 from '../../Images/mb_home_page_bg_2.jpg';
import mbHomeImg3 from '../../Images/mb_home_page_bg_3.jpg';
import formIcon from '../../Images/formIcon.png';
import { Button } from "primereact/button";
import FlexComponent from "../../components/FlexComponent";
import { useRef, useMemo } from "react";
import { TieredMenu } from "primereact/tieredmenu";
import { useNavigate } from "react-router-dom";

const Wrapper = () => {
  const isSuperuser = useSelector((state) => state.user.isSuperuser);
  const image = useSelector((state) => state.user.image);
  const userName = useSelector((state) => state.user.userName);
  const firstName = useSelector((state) => state.user.firstName);
  const superUserFormMenu = useRef(null);
  const navigate = useNavigate();

  // Array of mobile background images
  const mobileImages = [mbHomeImg1, mbHomeImg2, mbHomeImg3];

  // Select a random image for mobile view
  const randomMobileImage = useMemo(() => {
    return mobileImages[Math.floor(Math.random() * mobileImages.length)];
  }, []);

  return (
    <>
      <div
        className='table-container desktopview_home'
        style={{
          paddingBottom: '2rem',
          backgroundImage: `url("${isSuperuser ? adminLogo : image}")`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          position: 'relative'
        }}
      >
        <div
          className='table-inner-div'
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            zIndex: 0
          }}
        />
        <ReportingDashboard />
      </div>

      <div
        className='table-container mobileview_home'
        style={{
          paddingBottom: '2rem',
          backgroundImage: `url("${randomMobileImage}")`,
          backgroundSize: 'cover',
          backgroundPosition: 'center 6rem',
          backgroundRepeat: 'no-repeat',
          marginTop: "-14vh",
          minHeight: "98vh",
          position: 'relative'
        }}
      >
      </div>
      <div style={{
        position: "absolute",
        color: "white",
        bottom: "0",
        marginBottom: "30%",
        fontSize: "24px",
        padding: "1rem",
        width: "100%",
      }}
        className="mobileViewBottomContent"
      >
        <FlexComponent >
          <div style={{ lineHeight: "1.2" }}>
            <div>Hello,</div>
            <div style={{ textTransform: "capitalize" }} >{firstName || userName}</div>
          </div>
          <div>
            <TieredMenu
              model={[
                // { label: 'New Mortgage App', command: () => navigate('/new-app-form') },
                { label: 'New App', command: () => navigate('/new-app-form') },
                // { label: 'Legacy', command: () => navigate('/new-app') },
                //hidden { label: 'New Buyer App', command: () => navigate('/new-buyer-app') },
                // { label: 'New Loan SetUp Form', command: () => navigate('/new-loan-set-up-form') },
                { label: 'Quick App', command: () => navigate('/new-app-short') },
                //hidden { label: 'New Homeowner App', command: () => navigate('/new-homeowner-app') },
              ]}
              popup
              ref={superUserFormMenu}
              breakpoint="767px"
            />
            <Button
              style={{ background: "transparent", minWidth: "50px", boxShadow: "none" }}
              label={<FlexComponent style={{ fontWeight: '400' }}><img src={formIcon} style={{ width: "60px" }} alt="" /></FlexComponent>}
              onClick={(e) => superUserFormMenu.current.toggle(e)}
            />
          </div>
        </FlexComponent>
      </div>
    </>
  );
};

export default Wrapper;